"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValidator = exports.required = void 0;
const _ = __importStar(require("lodash"));
const VALIDATORS = {
    required
};
function required(options) {
    const errorMsg = _.get(options, 'errorMessage', 'Value required');
    return function requiredValidator(value) {
        let valid = !_.isNull(value) && !_.isUndefined(value) && value.length;
        return {
            valid,
            msg: valid ? null : errorMsg
        };
    };
}
exports.required = required;
const chain = validators => function validatorChain(value) {
    let res;
    for (let i = 0; i < validators.length; i++) {
        res = validators[i](value);
        if (!res.valid) {
            return res;
        }
    }
    return res;
};
const createValidator = (...validators) => {
    const v = _.map(validators, name => {
        const fn = VALIDATORS[name];
        if (!fn) {
            throw new TypeError(`invalid validator name: '${name}'`);
        }
        return fn();
    });
    return v.length === 1 ? v[0] : chain(v);
};
exports.createValidator = createValidator;
//# sourceMappingURL=validators.js.map